import styled from 'styled-components'

export const CultureHeroContainer = styled.div`
  height: 100vh;
  width: 100vw;
  position: relative;
  margin-top: 50px;
  @media (max-width: 500px) {
    margin: 0;
  }
`

export const TextContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 100;
`
